export default function updatePathPages() {
    // update button text in the heading of learning path pages
    try {
        if (document.body.classList.contains('learning-path-page')) {
            let registerBtn = document.querySelector('#purchase-button-wrapper-large .purchase-button-full-text');
            if (registerBtn) {
                registerBtn.innerText = 'Start Learning';
            }
        }
    } catch (e) {
        console.warn("Error updating registration button...", e);
    }
};
